module.exports = __webpack_public_path__ + "img/9788993260892.5d3bf315.jpg";